import Vue from 'vue'

/**
 * IMPORT GLOBALS FOR APP
 * Path being matched: @/globals/<any_folder>/<any_name>
 * Make sure to always specify name attribute inside component's object 
 * since we define component's name according to its name attribute
 */

const requireGlobals = require.context('@/globals', true, /.vue*$/)
const globalsUnparsed = []

requireGlobals.keys().forEach(key => {
    globalsUnparsed.push(requireGlobals(key))
})

globalsUnparsed.forEach(el => {
  Object.keys(el).forEach(key => {
    Vue.component(el[key].name, el[key])
  })
})